import type { Tagged } from 'type-fest';
import { dayjs } from '../../../shared/utils/date';
import { Account } from '../account';

export type _IdpData = {
  id: _IdpData.Id;
  type: _IdpData.Type;
  payload: unknown;
  grantId?: string | null;
  accountId?: Account.Id | null;
  userCode?: string | null;
  uid?: string | null;
  expiresAt?: dayjs | null;
  consumedAt?: dayjs | null;
  createdAt: dayjs;
  updatedAt: dayjs;
};

export namespace _IdpData {
  export type Id = Tagged<string, 'oidcIdpDataId'>;
  export namespace Id {
    export const FromString = (id: string): Id => id as Id;
  }

  export type Type =
    | 'Grant'
    | 'Session'
    | 'AccessToken'
    | 'AuthorizationCode'
    | 'RefreshToken'
    | 'DeviceCode'
    | 'ClientCredentials'
    | 'InitialAccessToken'
    | 'RegistrationAccessToken'
    | 'Interaction'
    | 'ReplayDetection'
    | 'PushedAuthorizationRequest'
    | 'BackchannelAuthenticationRequest';

  export type Props = {
    id: string;
    type: string;
    payload: unknown;
    grantId?: string | null;
    accountId?: string | null;
    userCode?: string | null;
    uid?: string | null;
    expiresAt?: string | Date | dayjs | null;
    consumedAt?: string | Date | dayjs | null;
    createdAt: string | Date | dayjs;
    updatedAt: string | Date | dayjs;
  };

  export const Construct = (props: Props): _IdpData => {
    return {
      id: Id.FromString(props.id),
      type: props.type as Type,
      payload: props.payload,
      grantId: props.grantId,
      accountId: props.accountId ? Account.Id.FromString(props.accountId) : null,
      userCode: props.userCode,
      uid: props.uid,
      expiresAt: props.expiresAt ? dayjs(props.expiresAt) : null,
      consumedAt: props.consumedAt ? dayjs(props.consumedAt) : null,
      createdAt: dayjs(props.createdAt),
      updatedAt: dayjs(props.updatedAt),
    };
  };
}
